/**
 * Copyright (c) 2024-present, Bruno Carvalho de Araujo.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */

export const theme = {
  colors: {
    primary: '#ef7e02'
  }
}

export type Theme = typeof theme
export default theme
